export default __webpack_public_path__ + "static/media/ProjectVault.c3c62c79.JPG";